import { ArrowRightIcon } from 'lucide-react'

import { Button, ButtonGroup, Modal, useBreakpoint } from 'slab'

import ProviderSearchV2 from './ProviderSearchV2'
import { useOnboarding } from '../OnboardingContext'
import { BottomSheetWithHeaderAndFooter } from './BottomSheetWithHeaderAndFooter'

export const ProviderSearchModal: React.FC<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
}> = ({ open, onOpenChange }) => {
  const { breakpointIsAtLeast } = useBreakpoint()
  const { refreshOnboardingInfo, onboardingData } = useOnboarding()
  const providers = onboardingData?.provider_preferences
  const zipCode = onboardingData?.member?.zip

  if (!zipCode) return null
  if (breakpointIsAtLeast('xs')) {
    return (
      <Modal
        open={open}
        onOpenChange={onOpenChange}
      >
        <Modal.Body>
          <Modal.Title>
            See if your providers are in-network
          </Modal.Title>
          <ProviderSearchV2
            hideDescription
            zip={zipCode}
            providers={providers}
            onSelect={() => {
              refreshOnboardingInfo()
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Modal.Button variant='secondary'>
              Back
            </Modal.Button>
            <Modal.Button variant='primary' rightIcon={ArrowRightIcon}>
              Continue
            </Modal.Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
    )
  }
  return (
    <BottomSheetWithHeaderAndFooter
      open={open}
      onOpenChange={onOpenChange}
      title='See if your providers are in-network'
      footer={
        <ButtonGroup>
          <Button onClick={() => onOpenChange(false)} variant='tertiary-deemphasized' size='large'>
            Cancel
          </Button>
          <Button onClick={() => onOpenChange(false)} variant='primary' rightIcon={ArrowRightIcon} size='large'>
            Continue
          </Button>
        </ButtonGroup>
      }
    >
      <ProviderSearchV2
        hideDescription
        zip={zipCode}
        providers={providers}
        onSelect={() => {
          refreshOnboardingInfo()
        }}
      />
    </BottomSheetWithHeaderAndFooter>
  )
}
